import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  FaStar,
  FaRegStar,
  FaFilter,
  FaUser,
  FaCalendar,
  FaEdit,
  FaTrash,
} from "react-icons/fa";
import { BiComment } from "react-icons/bi";
import { LuAward } from "react-icons/lu";
import { useDispatch, useSelector } from "react-redux";
import { getSessionRatings } from "../../redux/actions/mindfulness";

// Review data in JSON format
const reviewData = {
  averageRating: 4.5,
  totalReviews: 8,
  fiveStarReviews: 5,
  highestRatingsSessions: [
    {
      sessionName: "Anxiety Management Session",
      rating: 4.3,
      reviewsCount: 4,
    },
    {
      sessionName: "Stress Relief & Mindfulness",
      rating: 5.0,
      reviewsCount: 2,
    },
    {
      sessionName: "Academic Pressure Support",
      rating: 4.5,
      reviewsCount: 2,
    },
  ],
  ratingDistribution: {
    5: { count: 5, percentage: 63 },
    4: { count: 2, percentage: 25 },
    3: { count: 1, percentage: 13 },
    2: { count: 0, percentage: 0 },
    1: { count: 0, percentage: 0 },
  },
  reviews: [
    {
      id: 1,
      reviewerName: "Dr. Ritika Singh",
      rating: 5,
      date: "December 28, 2025",
      session: "Anxiety Management Session",
      comment:
        "Absolutely life-changing! Dr. Singh helped me develop practical coping strategies that I use daily. The session was professional, empathetic, and truly transformative.",
    },
    {
      id: 2,
      reviewerName: "Dr. Ritika Singh",
      rating: 5,
      date: "December 28, 2025",
      session: "Anxiety Management Session",
      comment:
        "Absolutely life-changing! Dr. Singh helped me develop practical coping strategies that I use daily. The session was professional, empathetic, and truly transformative.",
    },
  ],
};

// Styled Components
const PageContainer = styled.div`
  font-family: Montserrat;
  max-width: 80%;
  margin: 20px auto;
  padding: 20px;
  margin-top: 90px;
  /* background-color: #f9f9f9; */
  font-weight: 400;
`;

const Heading = styled.p`
  color: rgba(10, 10, 10, 1);
  font-family: Montserrat;
  font-style: Regular;
  font-size: 30px;
  font-weight: 400;
  line-height: 36px;
  letter-spacing: 0px;
  text-align: left;
`;

const SubHeading = styled.p`
  color: rgba(74, 85, 101, 1);
  font-family: Montserrat;
  font-style: Regular;
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
`;

const Header = styled.div`
  margin-bottom: 20px;

  h1 {
    font-size: 24px;
    font-weight: 400;
    color: #333;
    margin-bottom: 5px;
  }

  p {
    font-size: 14px;
    color: #666;
    margin: 0;
  }
`;

const StatsContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
  flex-wrap: wrap;
`;

const StatCard = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  flex: 1;
  /* min-width: 250px; */
  color: "#333";
  min-height: 150px;

  .icon {
    font-size: 20px;
    margin-right: 10px;
    vertical-align: middle;
  }

  .value {
    font-size: 2.25rem;
    font-weight: 400;
    margin: 10px 0;
  }

  .stars {
    display: flex;
    margin: 5px 0;

    .star {
      color: ${(props) => (props.primary ? "#fff" : "#ffc107")};
      font-size: 16px;
      margin-right: 2px;
    }
  }

  .subtext {
    font-family: Montserrat;
    font-style: Medium;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0px;
    text-align: left;

    &:hover {
      opacity: 1;
    }
  }

  &:hover {
    background: linear-gradient(
      135deg,
      rgba(250.58, 43.81, 54.33, 1) 0%,
      rgba(231.15, 0, 10.76, 1) 100%
    );
    color: #ffffff;
  }
`;

const Section = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 30px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  h2 {
    font-size: 18px;
    font-weight: 400;
    color: #333;
    margin-bottom: 15px;
  }
`;

const SessionsGrid = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
`;

const SessionCard = styled.div`
  background-color: #f9fafb;
  border-radius: 8px;
  padding: 15px;
  flex: 1;
  min-width: 250px;
  border: 1px solid rgba(229, 231, 235, 1);

  .session-name {
    font-weight: 400;
    margin-bottom: 5px;
    font-size: 14px;
  }

  .rating {
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    .star {
      color: #ffc107;
      font-size: 14px;
      margin-right: 2px;
    }

    .rating-value {
      font-weight: 400;
      margin-left: 5px;
      font-size: 14px;
      color: #0a0a0a;
    }
  }

  .reviews-count {
    font-size: 12px;
    color: #666;
  }
`;

const RatingBar = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 0;

  .label {
    width: 30px;
    font-weight: 400;
    font-size: 14px;
    text-align: right;
    margin-right: 1rem;
  }

  .bar-container {
    flex: 1;
    height: 10px;
    background-color: #e0e0e0;
    border-radius: 5px;
    overflow: hidden;
    margin-right: 10px;
  }

  .bar {
    height: 100%;
    background-color: #ffc107;
    border-radius: 5px;
  }

  .count {
    font-size: 14px;
    font-weight: 400;
    white-space: nowrap;
  }
`;

const FilterContainer = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
  padding: 15px 0;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 20px;

  .filter-label {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: #333;

    .icon {
      margin-right: 5px;
    }
  }

  select {
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    flex: 1;
  }

  .rating-filter {
    display: flex;
    gap: 5px;

    button {
      padding: 8px 12px;
      border: 1px solid #ddd;
      border-radius: 4px;
      background-color: #f9fafb;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 14px;

      &.active {
        background-color: #e71d36;
        color: white;
        border-color: #e71d36;
      }

      .star {
        font-size: 14px;
      }
    }
  }
`;

const ReviewsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ReviewCard = styled.div`
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  .review-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #e0e0e0;
      margin-right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      color: #333;
    }

    .reviewer-info {
      flex: 1;

      .name {
        font-weight: 400;
        font-size: 16px;
        margin-bottom: 5px;
      }

      .date {
        font-size: 12px;
        color: #666;
        margin-bottom: 5px;
      }

      .session {
        font-size: 12px;
        color: #e71d36;
        font-weight: 400;
        background-color: #ffebee;
        padding: 2px 6px;
        border-radius: 3px;
        display: inline-block;
      }
    }
  }

  .rating {
    display: flex;
    margin-bottom: 10px;

    .star {
      color: #ffc107;
      font-size: 16px;
      margin-right: 2px;
    }
  }

  .comment {
    font-size: 14px;
    line-height: 1.5;
    color: #333;
    margin-bottom: 15px;
  }

  .actions {
    display: flex;
    gap: 15px;
    font-size: 12px;

    button {
      background: none;
      border: none;
      cursor: pointer;
      color: #3498db;
      text-decoration: underline;
      padding: 0;

      &:hover {
        color: #2980b9;
      }
    }
  }
`;

const StarRating = ({ rating, size = 16 }) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(
      <span key={i} className="star">
        {i <= rating ? (
          <FaStar size={size} color="#ffc107" />
        ) : (
          <FaRegStar size={size} color="#ffc107" />
        )}
      </span>,
    );
  }
  return <div>{stars}</div>;
};

const MindfulnessUserReviewPage = () => {
  const [selectedRating, setSelectedRating] = useState("all");
  const [selectedSession, setSelectedSession] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useDispatch();
  const reviewData = useSelector(
    (state) => state?.mindfulness?.sessionRatings || [],
  );

  const filteredReviews = reviewData.reviews.filter((review) => {
    if (
      selectedRating !== "all" &&
      review.rating !== parseInt(selectedRating)
    ) {
      return false;
    }
    if (selectedSession && review.session !== selectedSession) {
      return false;
    }
    return true;
  });

  useEffect(async ()=>{
    await dispatch(getSessionRatings());
    

  }, [])

  return (
    <PageContainer>
      <Header>
        <h1>My Reviews & Ratings</h1>
        <p>Your feedback on counseling sessions you've attended</p>
      </Header>

      <StatsContainer>
        <StatCard primary>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "0.875rem",
              fontWeight: 400,
              gap: "0.75rem",
            }}
          >
            {" "}
            <FaStar color="#ffc107" size={24} /> Average rating given
          </div>
          <div className="value">{reviewData.averageRating}</div>
          <div className="stars">
            <StarRating rating={reviewData.averageRating} />
          </div>
          <div className="subtext">Click to view all reviews</div>
        </StatCard>

        <StatCard>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "0.875rem",
              fontWeight: 400,
              gap: "0.75rem",
            }}
          >
            <BiComment size={24} color="#2B7FFF" /> Reviews Written
          </div>
          <div className="value">{reviewData.totalReviews}</div>
          <div className="subtext">Across all sessions</div>
          <div className="subtext">Click to jump to reviews</div>
        </StatCard>

        <StatCard>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "0.875rem",
              fontWeight: 400,
              gap: "0.75rem",
            }}
          >
            <BiComment size={24} color="#F0B100" /> 5-Star Reviews
          </div>
          <div className="value">{reviewData.fiveStarReviews}</div>
          <div className="subtext">
            {Math.round(
              (reviewData.fiveStarReviews / reviewData.totalReviews) * 100,
            )}
            % of your reviews
          </div>
          <div className="subtext">Click to filter 5-star reviews</div>
        </StatCard>
      </StatsContainer>

      <Section>
        <h2>Your Highest Ratings Sessions</h2>
        <SessionsGrid>
          {reviewData.highestRatingsSessions.map((session, index) => (
            <SessionCard key={index}>
              <div className="session-name">{session.sessionName}</div>
              <div className="rating">
                <StarRating rating={session.rating} size={14} />
                <span className="rating-value">{session.rating}</span>
              </div>
              <div className="reviews-count">
                {session.reviewsCount} reviews
              </div>
            </SessionCard>
          ))}
        </SessionsGrid>
      </Section>

      <Section>
        <h2>My Rating Distribution</h2>
        {[5, 4, 3, 2, 1].map((star) => (
          <RatingBar key={star}>
            <div className="label">
              {star}
              <FaStar color="#ffc107" size={14} />
            </div>
            <div className="bar-container">
              <div
                className="bar"
                style={{
                  width: `${reviewData.ratingDistribution[star].percentage}%`,
                }}
              ></div>
            </div>
            <div className="count">
              {reviewData.ratingDistribution[star].count} (
              {reviewData.ratingDistribution[star].percentage}%)
            </div>
          </RatingBar>
        ))}
      </Section>

      <FilterContainer>
        <div className="filter-label">
          <FaFilter className="icon" /> Filter by session:
        </div>
        <select
          value={selectedSession}
          onChange={(e) => setSelectedSession(e.target.value)}
        >
          <option value="">All sessions</option>
          {Array.from(new Set(reviewData.reviews.map((r) => r.session))).map(
            (session) => (
              <option key={session} value={session}>
                {session}
              </option>
            ),
          )}
        </select>

        <div className="filter-label">Rating:</div>
        <div className="rating-filter">
          {["all", "5", "4", "3", "2", "1"].map((rating) => (
            <button
              key={rating}
              className={selectedRating === rating ? "active" : ""}
              onClick={() => setSelectedRating(rating)}
            >
              {rating === "all" ? (
                "All"
              ) : (
                <>
                  <FaStar size={14} />
                  {rating}
                </>
              )}
            </button>
          ))}
        </div>
      </FilterContainer>

      <Section>
        <h2>My Reviews ({filteredReviews.length})</h2>
        <ReviewsList>
          {filteredReviews.map((review) => (
            <ReviewCard key={review.id}>
              <div className="review-header">
                <div className="avatar">
                  <FaUser size={20} />
                </div>
                <div className="reviewer-info">
                  <div className="name">{review.reviewerName}</div>
                  <div className="date">{review.date}</div>
                  <div className="session">{review.session}</div>
                </div>
              </div>
              <div className="rating">
                <StarRating rating={review.rating} />
              </div>
              <div className="comment">{review.comment}</div>
              <div className="actions">
                <button>Edit Review</button>
                <button>Delete</button>
              </div>
            </ReviewCard>
          ))}
        </ReviewsList>
      </Section>
    </PageContainer>
  );
};

export default MindfulnessUserReviewPage;
